import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Grid, Text } from 'onefaceui-react-components';

import Modal from 'react/components/Modal/Modal';

import { getResourceTo } from 'react/utils/utils';
import { actionCreators } from 'react/api/actions/modals';
import { useDataSyncLogDetails } from 'react/queries/DataSyncLogDetails';

import Loading from 'react/components/Loading';

function DataSyncLogDetailsModal() {
  const MODAL_KEY = 'dataSyncLogDetails';

  const dispatch = useDispatch();

  const isOpen = useSelector((state) => state.modals.getIn([MODAL_KEY, 'isOpen']));
  const title = useSelector((state) => state.modals.getIn([MODAL_KEY, 'title']));
  const data = useSelector((state) => state.modals.getIn([MODAL_KEY, 'data']).toJS());

  const { data: logDetails, isFetching } = useDataSyncLogDetails(data.id)

  const closeModal = useCallback(() => {
    dispatch(actionCreators.closeModal({
      modalKey: MODAL_KEY
    }));
  }, []);

  const ModalFooter = (
    <div className="footerModal">
      <button
        data-testid="close-logdetails-modal"
        type="button"
        className="btn-secondary"
        onClick={closeModal}
      >
        {getResourceTo('default.button.close')}
      </button>
    </div>
  );

  const formatJSONMessage = (jsonText) => {
    try {
      return JSON.stringify(jsonText, null, 2).replace(/"/g, '');
    } catch (error) {
      return jsonText;
    }
  };

  const getSafeValueTo = (value) => value ?? "---";

  function getContainer() {
    let container = document
      .querySelector('.mainContainer .reactivo-tabs.gmTabs #logsDetailsModalWrapper');

    if (!container) {
      container = document.createElement('div');
      container.id = 'logsDetailsModalWrapper';

      document.querySelector('.mainContainer .reactivo-tabs.gmTabs').appendChild(container);
    }

    return container;
  }

  if (!isOpen) return null;

  return (
    <Modal
      className="logDetailsModal"
      isOpen={isOpen}
      title={getResourceTo(title)}
      crossAxisBtn={false}
      footer={ModalFooter}
      closeModalFn={closeModal}
      parentSelector={() => getContainer()}
    >
      <div className="modalBody" data-testid="modal-logdetails-body">
        <Flex shouldShow={isFetching} justifyContent="center">
          <Loading width='64px' height='64px'  />
        </Flex>
        <Grid shouldShow={!isFetching} templateColumns="1fr 1fr">
          <Flex flexDirection="column" gap={10}>
            <div>
              <p className="titleDetail">{getResourceTo('stop.id')}</p>
              <Text size="sm" data-testid="logdetails-id">{data.id}</Text>
            </div>
            <div>
              <p className="titleDetail">{getResourceTo('dataSyncConfiguration.fields.status')}</p>
              <Text size="sm" data-testid="logdetails-statusProcess">{getSafeValueTo(data.statusProcess)}</Text>
            </div>
            <div>
              <p className="titleDetail">{getResourceTo('dataSyncLogs.fields.startProcessDate')}</p>
              <Text size="sm" data-testid="logdetails-startProcessDate">{getSafeValueTo(data.startProcessDate)}</Text>
            </div>
            <div>
              <p className="titleDetail">{getResourceTo('dataSyncLogs.fields.endProcessDate')}</p>
              <Text size="sm" data-testid="logdetails-endProcessDate">{getSafeValueTo(data.endProcessDate)}</Text>
            </div>
            <div>
              <p className="titleDetail">{getResourceTo('dataSyncLogs.fields.fileSize')}</p>
              <Text size="sm" data-testid="logdetails-compressedSize">{getSafeValueTo(data.compressedSize)}</Text>
            </div>
            <div>
              <p className="titleDetail">{getResourceTo('dataSyncLogs.fields.compressedFileName')}</p>
              <Text size="sm" data-testid="logdetails-compressedFileName">{getSafeValueTo(data.compressedFileName)}</Text>
            </div>
          </Flex>
          <Flex flexDirection="column" gap={10}>
            <div className="requestBody">
              <p className="titleDetail">{getResourceTo('dataSyncLog.field.metaFilters')}</p>
              <span className="preRequest">
                <pre>{formatJSONMessage(logDetails?.metaFilters ?? {})}</pre>
              </span>
            </div>
          </Flex>
        </Grid>
      </div>
    </Modal>
  );
}

export default memo(DataSyncLogDetailsModal);
